module.exports = __webpack_public_path__ + "img/express.68e13f9a.jpg";